import { Cached } from '@mui/icons-material';
import RefreshIcon from '@mui/icons-material/Refresh';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  styled,
  IconButton,
  Grid,
  Box,
  Tooltip,
} from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { getJobBoardDetailsByName, IJobBoardDTO, updateMonsterCreditsData } from 'wisestep-api';
import {
  WsButton,
  WsColors,
  WsIconEdit,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import {
  useNativeSearchAccessControl,
  NativeSearchAction,
} from '../../../../../hooks/useNativeSearchAccessControl';
import Monster from '../../../../../images/jobBoardsIcons/Monster.png';
import NativeSearchSettings from '../../../NativeSearchSettings';
import AccountSettings from '../../accountSettings/AccountSettings';
import SearchSharedUser from '../../searchSharedUser/SearchSharedUser';
import { NativeDialogHeader } from '../dice/DiceNewAccount';
const CustomTableHeadCell = styled(TableCell)(() => ({
  paddingLeft: 32,
  fontWeight: 600,
  fontSize: '14px',
  color: WsColors.TertiaryShades600,
  cursor: 'pointer',
}));

export default function MonsterAccount() {
  const { access, owns } = useNativeSearchAccessControl([
    NativeSearchAction.MANAGE_NATIVE_SEARCH_ACCOUNTS,
  ]);
  const [manage] = access;
  const [configuredAcc, setConfiguredAcc] = useState<IJobBoardDTO[]>([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [isDataRetrieved, setIsDataRetrieved] = useState<boolean>(false);
  const [country, setCountry] = useState<string>('');
  const [indexValue, setIndexValue] = useState<number>(-1);
  const closeDrawer = () => {
    setShowDrawer(false);
    setIndexValue(-1);
  };
  useEffect(() => {
    const fetchJobBoardAcc = async () => {
      const response = await getJobBoardDetailsByName('MONSTER', '');
      if (response.data) {
        const monsterData = response.data;
        setConfiguredAcc(monsterData);
        setIsDataRetrieved(true);
      }
      setRefresh(false);
    };
    if (!isDataRetrieved || refresh) {
      fetchJobBoardAcc();
    }
  }, [isDataRetrieved, refresh]);

  const getLatest = async () => {
    const response = await getJobBoardDetailsByName('MONSTER', 'true');
    if (response.data) setConfiguredAcc(response.data);
  };

  const updaterFunction = (data, index) => {
    console.log(data, index, 'updaterFunction');
  };

  const getSharedCount = (items, country) => {
    return items?.filter((obj) => obj.country === country).length;
  };

  const getData = () => {
    return configuredAcc[indexValue];
  };

  const handleQuotaRefresh = async (jobBoard: IJobBoardDTO) => {
    await updateMonsterCreditsData(jobBoard.id);
    setRefresh(true);
  };

  return (
    <>
      <NativeSearchSettings>
        <Box borderRadius={1.5} bgcolor="white">
          <NativeDialogHeader>
            <Grid item container xs={10} columnGap={2}>
              <img src={Monster} alt="Monster" height="35" />
              <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
                Monster
              </WsTypography>
            </Grid>
            <Grid container>
              <Grid item container xs={10} columnGap={2}>
                <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
                  API Integrated Search Accounts
                </WsTypography>
              </Grid>
              <Grid item container xs={2} justifyContent="flex-end">
                <WsButton startIcon={<RefreshIcon fontSize="small" />} onClick={() => getLatest()}>
                  Refresh Account
                </WsButton>
              </Grid>
            </Grid>
          </NativeDialogHeader>
          <SearchSharedUser setAccounts={setConfiguredAcc} jobBoardName={'MONSTER'} />
          <Table>
            <TableHead>
              <TableRow>
                <CustomTableHeadCell>Account Name</CustomTableHeadCell>
                <CustomTableHeadCell align="center">Geography</CustomTableHeadCell>
                <CustomTableHeadCell align="center">Quota</CustomTableHeadCell>
                <CustomTableHeadCell align="center">Shared With</CustomTableHeadCell>
                <CustomTableHeadCell align="center">Actions</CustomTableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {configuredAcc.map((item, index) => (
                <Fragment key={index}>
                  <TableRow>
                    <TableCell rowSpan={(item?.subAccounts ?? [])?.length + 1}>
                      <b>{item.username}</b>
                    </TableCell>
                  </TableRow>
                  {(item.subAccounts ?? []).map((detail, innerIndex) => (
                    <TableRow key={innerIndex}>
                      <TableCell align="center">
                        <b>{detail?.country?.toUpperCase()}</b>
                      </TableCell>
                      <TableCell align="center">
                        <b>
                          {detail.usage?.viewsRemaining}/{detail.usage?.quota}
                        </b>
                      </TableCell>
                      <TableCell align="center">
                        <b>
                          {getSharedCount(
                            item.jobBoardSearchAccountUsers,
                            detail?.country?.toUpperCase()
                          )}
                        </b>
                      </TableCell>
                      <TableCell>
                        {(owns || manage) && (
                          <IconButton
                            onClick={() => {
                              setShowDrawer(true);
                              setIndexValue(index);
                              setCountry(detail?.country ?? '');
                            }}
                          >
                            <WsIconEdit />
                          </IconButton>
                        )}
                        <Tooltip title="Refresh Quota">
                          <IconButton onClick={() => handleQuotaRefresh(item)}>
                            <Cached />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </Fragment>
              ))}
            </TableBody>
          </Table>
        </Box>
      </NativeSearchSettings>
      {indexValue != -1 && (
        <Grid marginTop={2} borderRadius={1.5}>
          <AccountSettings
            openDrawer={showDrawer}
            closeDrawer={() => closeDrawer()}
            accountType={'MONSTER'}
            tableData={getData()}
            dataIndex={indexValue}
            country={country}
            dataUpdater={(data, index) => updaterFunction(data, index)}
          />
        </Grid>
      )}
    </>
  );
}
